
//bao migrate skip
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import BaoMenu from "./../../services/bao-menu";
import SearchPaging from "./../../factories/search-paging";
import BaoDialogViewModel from "./../../factories/bao-dialog";
import TabPage from "./../../factories/tab-page";
import TabViewModel from "./../../factories/tab-controller";
import "./../../bindings/bao-searcher";
import "./../../bindings/bao-tabs";
import AppTabController from "../../services/app-tab-controller";
function RoleViewModel(tabPage) {
    var self = this;
    SearchPaging.call(this, tabPage);
    self.CompleteCheck = function () {
        var isComplete = true;
        var def = $.Deferred();
        if (self.RoleName() == null || self.RoleName() == "") {
            isComplete = false;
        }
        $.each(self.TabViewModel.Tabs(), function (index, tab) {
            if (tab.PreLoad()) {
                if (!tab.ViewModel().CompleteCheck()) {
                    self.TabViewModel.SelectTab(tab);
                    isComplete = false;
                    return false;
                }
            }
        });
        if (!isComplete) {
            new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
            def.resolve(false);
        }
        else {
            self.ValidateRolename().then(function (result) {
                if (result.Result == false) {
                    new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgRoleExistsInDb"), "info");
                    def.resolve(false);
                }
                else {
                    def.resolve(true);
                }
            });
        }
        return def.promise();
    };
    self.ValidateRolename = function () {
        return Bao.post("Uadm/Role/ValidateRolename", JSON.stringify({
            roleId: self.RoleId(),
            roleName: self.RoleName()
        }));
    };
    self.TabViewModel = new TabViewModel(false);
    self.RoleTabs = ko.observableArray([]);
    self.RoleTabs.subscribe(function (newValue) {
        self.TabViewModel.Tabs([]);
        $.each(ko.toJS(newValue), function (index, item) {
            if (item.PreLoad == null) {
                item.PreLoad = false;
            }
            var newTab = new TabPage(null, item.Caption);
            newTab.AutoSelect = false;
            newTab.Url(item.WebUrl);
            newTab.IsClosable(false);
            newTab.PreLoad(item.PreLoad);
            newTab.TabLoaded = function () { };
            self.TabViewModel.AddTab(newTab);
        });
        if (self.TabViewModel.Tabs().length > 0) {
            self.TabViewModel.SelectTab(self.TabViewModel.Tabs()[0]);
        }
    });
    self.PerformRefresh = function () {
        tabPage.IsLoading(true);
        return Bao.post(self.RefreshUrl, JSON.stringify({
            id: self.OpenData()
        }), function (value) {
            tabPage.DirtyFlag.pause();
            tabPage.ObjectId(self.OpenData());
            delete value.RoleTabs;
            ko.map.fromJS(value, self);
            self.TabViewModel.RefreshTabs().then(function () {
                tabPage.IsLoading(false);
                tabPage.DirtyFlag.reset();
            });
        });
    };
    self.Save = function () {
        tabPage.IsLoading(true);
        return Bao.post(self.SaveUrl, JSON.stringify({
            model: self.MinimizeEntity()
        }), function (value) {
            self.SaveTime(value.Result);
            self.TabViewModel.SaveTabs(value.Result).then(function () {
                tabPage.DirtyFlag(false);
                self.PerformRefresh();
            });
        });
    };
    self.MinimizeEntity = function () {
        var result = ko.map.toJS(self, true);
        delete result.RoleTabs;
        delete result.Destroy;
        delete result.TabPage;
        delete result.TabViewModel;
        delete result.Uadm;
        return result;
    };
    BaoMenu.registerEvent(function (value) {
        if (tabPage.IsActiveTab() == true) {
            switch (value.ActionKey()) {
                case "RoleCopy":
                    self.CopyRole();
                    break;
                case "RoleAudit":
                    self.OpenAuditDialog();
                    break;
            }
        }
    });
    self.OpenAuditDialog = function () {
        window.baorequire(["Factories/BaseAuditDialog"], function (vm) {
            var auditDialog = new vm(self.RoleId(), ko.unwrap(self.TabPage.Title), self.TabPage, "Uadm/Role/GetAuditCollection");
            auditDialog.Open();
        });
    };
    var msgCopyRoleMessage = Bao.Session.GetMessage("msgCopyRoleMessage");
    self.CopyRole = function () {
        var yesNoDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, msgCopyRoleMessage, "yesno");
        yesNoDialog.DialogResult.subscribe(function (result) {
            if (result === true) {
                tabPage.IsLoading(true);
                return Bao.post("Uadm/Role/Copy", JSON.stringify({
                    model: self.MinimizeEntity()
                }), function (value) {
                    self.SaveTime(value.SaveTime);
                    var roleId = value.NewRoleId;
                    self.CopyRoleTabs(roleId);
                    var newTab = new TabPage();
                    newTab.Url("Uadm/Role/Index");
                    newTab.UrlData({
                        id: roleId
                    });
                    newTab.ObjectId(roleId);
                    AppTabController.AddTab(newTab);
                    tabPage.IsLoading(false);
                });
            }
        });
    };
    self.CopyRoleTabs = function (roleId) {
        var saveDefArray = [];
        ko.utils.arrayForEach(self.TabViewModel.Tabs(), function (tab: any) {
            if (tab.Loaded() == true && tab.ViewModel() != null && typeof tab.ViewModel().Copy == "function") {
                saveDefArray[saveDefArray.length] = tab.ViewModel().Copy(roleId, self.SaveTime());
            }
        });
        return $.when.apply($, saveDefArray);
    };
}
;
Bao.inherit(RoleViewModel, SearchPaging);
RoleViewModel.prototype.PrimaryKey = "RoleId";
RoleViewModel.prototype.DeleteMessageKey = "msgDeleteRole";
RoleViewModel.prototype.RefreshUrl = "Uadm/Role/GetRole";
RoleViewModel.prototype.SaveUrl = "Uadm/Role/SaveRole";
RoleViewModel.prototype.DeleteUrl = "Uadm/Role/Delete";
RoleViewModel.prototype.PermissionForward = "RoleMoveForwardSearch";
RoleViewModel.prototype.PermissionBackward = "RoleMoveBackwardSearch";
RoleViewModel.prototype.PermissionSave = "RoleSave";
RoleViewModel.prototype.PermissionRefresh = "RoleRefresh";
RoleViewModel.prototype.PermissionDelete = "RoleDelete";
export default RoleViewModel;